import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Shop from "../pages/Shop/Shop";
import ScrollToHashElement from "./ScrollToHashElement";

import Terms from "../pages/InfoPages/Terms";
import Impressum from "../pages/InfoPages/Impressum";
import Retouren from "../pages/InfoPages/Retouren";
import Datenschutzerklarung from "../pages/InfoPages/Datenschutzerklarung";
import Versandbedingungen from "../pages/InfoPages/Versandbedingungen";
import Widerrufsrecht from "../pages/InfoPages/Widerrufsrecht";
import PaymentSuccess from "@/pages/InfoPages/PaymentSuccess";
import PaymentFailed from "@/pages/InfoPages/PaymentFailed";
import FeedbackSuccess from "@/pages/InfoPages/FeedbackSuccess";

import ProductDetailPage from "../pages/ProductDetailPage/ProductDetailPage";
import ServiceBerlin from "../pages/ServiceBerlin";
import ServiceEU from "../pages/ServiceEU";
import UberUns from "../pages/UberUns";
import Kontakt from "../pages/Kontakt";
import FAQ from "../pages/FAQ";
import Partner from "../pages/Partner";
import Karriere from "../pages/Karriere";
import Reviews from "@/pages/Reviews";

import Checkout from "@/pages/Checkout";
import NotFound from "@/pages/NotFound/NotFound";

const AppRoutes = () => {
  return (
    <>
      <ScrollToHashElement />
      <Routes>
        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* Shop */}
        <Route path="/shop" element={<Shop />} />
        <Route
          path="/shop/:section/:categoryId/:categoryName"
          element={<Shop />}
        />
        <Route path="/:section/:id/:name" element={<ProductDetailPage />} />

        {/* Services */}
        <Route path="/services/berlin" element={<ServiceBerlin />} />
        <Route path="/services/eu" element={<ServiceEU />} />

        {/* Company */}
        <Route path="/about-us" element={<UberUns />} />
        <Route path="/partners" element={<Partner />} />
        <Route path="/career" element={<Karriere />} />

        {/* Support */}
        <Route path="/contact" element={<Kontakt />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/reviews" element={<Reviews />} />

        {/* Legal */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Datenschutzerklarung />} />
        <Route path="/imprint" element={<Impressum />} />
        <Route path="/cancellation" element={<Widerrufsrecht />} />
        <Route path="/shipping" element={<Versandbedingungen />} />
        <Route path="/returns" element={<Retouren />} />

        {/* Checkout & Payment */}
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment_success" element={<PaymentSuccess />} />
        <Route path="/payment_failed" element={<PaymentFailed />} />
        <Route path="/feedback_success" element={<FeedbackSuccess />} />

        {/* 404 - Must be last */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
